export enum ProcessFileType {
  XKT = 'xkt',
  IFC = 'ifc',
  GLB = 'glb',
  BIM = 'bim',
  LAS = 'las',
  STL = 'stl',
  OBJ = 'obj',
  MTL = 'mtl',
  STEP = 'step',
  ZIP = 'zip',
  JSON = 'json',
  LOG = 'log',
  DB = 'db',
  RVT = 'rvt',
  RFA = 'rfa',
  NWD = 'nwd',
  NWC = 'nwc',
}

export function getProcessFileType(extension: string | undefined): ProcessFileType | null {
  if (!extension) return null;

  const lowerExt = extension.toLowerCase();

  if (lowerExt === 'stp') return ProcessFileType.STEP;
  if (lowerExt === 'laz') return ProcessFileType.LAS;

  return Object.values(ProcessFileType).includes(lowerExt as ProcessFileType)
    ? (lowerExt as ProcessFileType)
    : null;
}
